import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const YearPicker = ({
    value,
    onChange,
    sx = {},
    name,
    InputProps,
    placeholder
}) => {
    const previousMonth = dayjs().endOf("month");
    const validValue = !value || dayjs(value).isAfter(previousMonth) ? null : dayjs(value);
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                views={["year", "month"]}
                value={validValue}
                onChange={onChange}
                sx={{
                    width: "100%",
                    maxWidth: "200px",
                    backgroundColor:" transparent",
                    ...sx,
                    borderRadius:'30px',
                    color: "white !important",
                    "& .MuiOutlinedInput-root": {
                        color: "white !important",
                        padding: "0px",
                        border:'none',
                        "&.Mui-focused": {
                            border: "none", 
                            outline: "none", 
                        },
                    },
                    "& .MuiSvgIcon-root": {
                        fill: "white !important",
                    }
                }}
                InputProps={InputProps}
                name={name}
                maxDate={previousMonth}
                placeholder={placeholder}
            />
        </LocalizationProvider>
    );
};

export default YearPicker;
